// Árvore do menu, consumida pelas duas skins do React (AppSidebar e
// LegacyTopBar, via components/layout/resolvedMenu.ts). Ícones ficam em
// components/layout/menuIcons.ts.
//
// Até a Fase 7 este arquivo também guardava o dono (react/angular) de cada
// rota e era lido em Node por um gerador para o lado Angular — ver
// docs/migracao/decisoes.md (D2) e diario.md (Fase 7, decomissionamento).

export interface MenuLeaf {
  label: string;
  /** Caminho do react-router (ex. "/Usuario/Consulta"). */
  path: string;
  /** ROLE_* de usuario-logado.roles — omitido quando a rota é livre. */
  role?: string;
}

export interface MenuGroup {
  label: string;
  children: MenuLeaf[];
}

export type MenuEntry = MenuLeaf | MenuGroup;

export function isMenuGroup(entry: MenuEntry): entry is MenuGroup {
  return "children" in entry;
}

// Mesma forma do menu horizontal do legado, mais Usuários e Notificações, que lá
// viviam só no dropdown de usuário; cada skin decide onde exibi-los.
export const MENU: MenuEntry[] = [
  { label: "Início", path: "/" },
  {
    label: "Instituições",
    children: [
      { label: "Cadastro", path: "/Instituicao/Form" },
      { label: "Consulta", path: "/Instituicao/Consulta" },
      { label: "Interações", path: "/InstituicaoInteracao/Consulta" },
      { label: "Cobranças", path: "/Cobranca/Consulta" },
      { label: "Lista Health Score", path: "/Instituicao/HealthScore" },
      { label: "Frequência de acessos", path: "/Acessos/Frequencia" },
      { label: "Importar Idosos", path: "/Importacao/Idoso" },
      { label: "Importar Profissionais", path: "/Importacao/Profissional" },
      { label: "Exportação de Backup CSV", path: "/Relatorios/ExportacaoBackupCsv" },
    ],
  },
  {
    label: "Silpi Farma",
    children: [{ label: "Dashboard", path: "/SilpiFarma/Dashboard" }],
  },
  {
    label: "Franquias",
    children: [
      { label: "Cadastrar Franquia", path: "/Franquia/Adicionar" },
      { label: "Consulta de Franquias", path: "/Franquia/Consulta" },
    ],
  },
  {
    label: "Cadastros",
    children: [
      { label: "Tipo de Arquivo", path: "/TipoArquivo/Consulta" },
      { label: "Layouts de notificação", path: "/LayoutNotificacao/Consulta" },
      { label: "Mensageria", path: "/Mensageria/Consulta" },
    ],
  },
  { label: "Usuários", path: "/Usuario/Consulta" },
  { label: "Notificações", path: "/Notificacao/Consulta" },
];
